<template>
  <v-dialog
    :value="value"
    max-width="520"
    @input="onInput"
  >
    <v-card>
      <v-card-title class="text-h6">
        {{ userName }} の中間値
      </v-card-title>

      <v-card-text>
        <template v-if="isLoading">
          <v-skeleton-loader type="table" />
        </template>

        <template v-else-if="values.length > 0">
          <v-simple-table>
            <template #default>
              <thead>
                <tr>
                  <th class="text-left">
                    集計表
                  </th>
                  <th class="text-left">
                    項目
                  </th>
                  <th class="text-left">
                    集計方法
                  </th>
                  <th class="text-right">
                    値
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in values"
                  :key="`${item.businessRuleId}-${index}`"
                >
                  <td class="text-left">
                    {{ item.aggregationName }}
                  </td>
                  <td class="text-left">
                    {{ item.name }}
                  </td>
                  <td class="text-left">
                    {{ displayTypeLabel(item.displayType) }}
                  </td>
                  <td class="text-right">
                    {{ item.value }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>

        <template v-else>
          <v-alert
            type="info"
            text
            dense
            class="mb-0"
          >
            中間値はありません
          </v-alert>
        </template>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="onInput(false)"
        >
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    values: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    userName: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const onInput = val => {
      emit('input', val)
    }

    const displayTypeLabel = type => {
      const labels = {
        sum: '合計',
        last: '最新値',
        max: '最大',
        avg: '平均',
        unique: '種類数',
      }

      return labels[type] || type
    }

    return {
      onInput,
      displayTypeLabel,
    }
  },
}
</script>
